export default __webpack_public_path__ + "static/media/IMG_8335.03768157.jpeg";